import { render, staticRenderFns } from "./TestResultAudiometry.vue?vue&type=template&id=623bdc0e&"
import script from "./TestResultAudiometry.vue?vue&type=script&lang=js&"
export * from "./TestResultAudiometry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports